<template>
  <div class="formsign">
    <div class="pagePopMask pFull" v-if="formsign" @click="cancelImpEdit"></div>
    <div class="pagePop w1280 pCenter" v-if="formsign">
      <div class="w">
        <div class="tit fnt_24">{{ titleName }}</div>
        <div class="cont">
          <div class="stform">
            <a-form-model ref="realForm" :model="model">
              <a-row :gutter="18">
                <!-- 团队信息 -->
                <template v-for="item in columnList">
                  <div :key="`team-${item.fieldCode || item.fieldSort}`" v-if="item.isShow === '1' || item.isDoubleCheck" v-show="isShowLeader">
                    <a-col :xs="24" :sm="24" :md="item.isStandalone === '0' ? 12 : 24" :lg="item.isStandalone === '0' ? 12 : 24" :xl="item.isStandalone === '0' ? 12 : 24">
                      <a-form-model-item
                        :label="item.fieldName" :prop="`data.${item.fieldCode}`"
                        :rules="buildFieldRules(item, 'team')"
                        :extra="item.prompt && item.prompt[0] ? item.prompt[0] : ''"
                      >
                        <!-- 普通输入框 -->
                        <a-input
                          :disabled="readOnly" v-if="item.fieldType === 'text' && item.fieldCode=== 'userPhoneNew'"
                          @input="handleNumberInput($event, item.fieldCode, '-1')"
                          v-model="model.data[item.fieldCode]" :placeholder="`${pleaseInput} ${item.fieldName}`"
                        />
                        <a-input
                          :disabled="readOnly"
                          v-else-if="item.fieldType === 'text' && item.fieldCode === 'instructor'"
                          v-model="model.data[item.fieldCode]"
                          :placeholder="globalDataArray.siteTemplateLanguage.sign_instructor_placeholder"
                        />
                        <a-input :disabled="readOnly" v-else-if="item.fieldType === 'text'" v-model="model.data[item.fieldCode]" :placeholder="`${pleaseInput} ${item.fieldName}`" />

                        <!-- 普通单选框 -->
                        <a-radio-group
                          v-else-if="item.fieldType === 'radio' && item.fieldCode === 'teamType'"
                          @change="onChangeFieldType"
                          v-model="model.data[item.fieldCode]"
                          :disabled="readOnly"
                        >
                          <a-radio :value="ca.itemValue" v-for="(ca,index) in item.list" :key="ca.itemValue">
                            {{ ca.itemText }}
                            <a-tooltip placement="bottom">
                              <a-icon type="question-circle" title="" />
                              <template slot="title">
                                <span v-html="item.tipsmsg ? item.tipsmsg[index]?.content : ''"></span>
                              </template>
                            </a-tooltip>
                          </a-radio>
                        </a-radio-group>
                        <a-radio-group
                          v-else-if="item.fieldType === 'radio'"
                          v-model="model.data[item.fieldCode]"
                          :disabled="readOnly"
                        >
                          <a-radio :value="ca.itemValue" v-for="(ca) in item.list" :key="ca.itemValue">
                            {{ ca.itemText }}
                          </a-radio>
                        </a-radio-group>

                        <!-- 下拉框 -->
                        <a-select
                          :placeholder="pleaseSelect + item.fieldName" v-else-if="item.fieldType === 'select' && item.fieldCode === 'groupId'"
                          v-model="model.data[item.fieldCode]" :disabled="readOnly" @change="onChangeGroupId"
                          :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                        >
                          <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                            {{ po.itemText }}
                          </a-select-option>
                        </a-select>
                        <a-select
                          :placeholder="pleaseSelect + item.fieldName" v-else-if="item.fieldType === 'select'" v-model="model.data[item.fieldCode]" :disabled="readOnly"
                          :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                        >
                          <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                            {{ po.itemText }}
                          </a-select-option>
                        </a-select>

                        <!-- 文件上传 -->
                        <file-upload-new :disabled="readOnly" v-else-if="item.fieldType === 'upload'" v-model="model.data[item.fieldCode]" />
                      </a-form-model-item>
                    </a-col>
                  </div>
                </template>

                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-show="isShowLeader">
                  <div class="line" v-if="!isYouthTemplate()"></div>
                </a-col>

                <!-- 队长信息-->
                <!-- 队长区块：青少年模板下不显示 -->
                <div v-if="!isYouthTemplate()">
                  <template v-for="item in showList">
                    <div :key="`captain-${item.fieldCode || item.fieldSort}`" v-if="item.isShow === '1' || item.isDoubleCheck" v-show="isShowLeader">
                      <a-col :xs="24" :sm="24" :md="item.isStandalone === '0' ? 12 : 24" :lg="item.isStandalone === '0' ? 12 : 24" :xl="item.isStandalone === '0' ? 12 : 24">
                        <a-form-model-item
                          :label="item.fieldName" :prop="`data.${item.fieldCode}`"
                          :rules="buildFieldRules(item, 'captain')"
                          :extra="item.prompt && item.prompt[0] ? item.prompt[0] : ''"
                        >
                          <!-- 生日选择框 -->
                          <a-date-picker
                            value-format="YYYY-MM-DD"
                            :locale="locale"
                            v-if="item.fieldCode === 'birthday'"
                            :disabled="readOnly"
                            v-model="model.data[item.fieldCode]"
                            @change="onBirthdayChange($event, '-1')"
                          />

                          <!-- 下拉框 -->
                          <a-select
                            v-else-if="item.fieldCode === 'company' && item.isDoubleCheck"
                            :disabled="readOnly"
                            show-search
                            allow-clear
                            :filter-option="false"
                            :placeholder="pleaseSelect"
                            :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                            v-model="model.data[item.fieldCode]"
                            @search="searchCollege"
                          >
                            <a-select-option v-for="(fi, index) in filterdCollegeList" :key="`captain-${fi.identificationCode || index}-${fi.name}`" :value="fi.name">
                              {{ fi.name }}
                            </a-select-option>
                          </a-select>
                          <a-select
                            :label-in-value="true"
                            :disabled="readOnly"
                            :placeholder="pleaseSelect"
                            v-else-if="item.fieldCode === 'countryCode'" @change="handleProvinceChange($event, '-1')"
                            v-model="model.data[item.fieldCode]"
                            :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                          >
                            <a-select-option :value="po.parentId" v-for="po in item.list" :key="po.parentId">
                              {{ po.title }}
                            </a-select-option>
                          </a-select>
                          <a-select
                            :label-in-value="true"
                            :disabled="readOnly"
                            :placeholder="pleaseSelect"
                            v-else-if="item.fieldCode === 'cityCode'"
                            v-model="model.data[item.fieldCode]"
                            :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                          >
                            <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                              {{ po.itemText }}
                            </a-select-option>
                          </a-select>
                          <a-select
                            :placeholder="pleaseSelect"
                            v-else-if="item.fieldType === 'select'"
                            :disabled="readOnly"
                            v-model="model.data[item.fieldCode]"
                            :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                          >
                            <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                              {{ po.itemText }}
                            </a-select-option>
                          </a-select>

                          <!-- 普通输入框 -->
                          <a-input
                            @input="handleNumberInput($event, item.fieldCode, '-1')"
                            v-else-if="item.fieldType === 'text' && item.fieldCode === 'userPhone'"
                            :disabled="readOnly || item.readOnly"
                            v-model="model.data[item.fieldCode]"
                          />
                          <a-input
                            v-else-if="item.fieldType === 'text'"
                            :disabled="readOnly || item.readOnly"
                            v-model="model.data[item.fieldCode]"
                          />

                          <!-- 普通单选框 -->
                          <a-radio-group
                            v-else-if="item.fieldType === 'radio' && item.fieldCode === 'companyType'"
                            :disabled="readOnly"
                            @change="onChangeCompany"
                            v-model="model.data[item.fieldCode]"
                          >
                            <a-radio :value="ca.itemValue" v-for="(ca) in item.list" :key="ca.itemValue">
                              {{ ca.itemText }}
                            </a-radio>
                          </a-radio-group>
                          <a-radio-group
                            v-else-if="item.fieldType === 'radio' && item.fieldCode === 'jobType'"
                            :disabled="readOnly"
                            @change="onChangeJob($event, '-1')"
                            v-model="model.data[item.fieldCode]"
                          >
                            <a-radio :value="ca.itemValue" v-for="(ca) in item.list" :key="ca.itemValue">
                              {{ ca.itemText }}
                            </a-radio>
                          </a-radio-group>
                          <a-radio-group
                            v-else-if="item.fieldType === 'radio'"
                            :disabled="readOnly"
                            v-model="model.data[item.fieldCode]"
                          >
                            <a-radio :value="ca.itemValue" v-for="(ca) in item.list" :key="ca.itemValue">
                              {{ ca.itemText }}
                            </a-radio>
                          </a-radio-group>

                          <!-- 文件上传 -->
                          <file-upload-new :disabled="readOnly" v-else-if="item.fieldType === 'upload' && item.fieldCode === 'studentUrl'" v-model="model.data[item.fieldCode]" accept=".jpg, .jpeg, .png, .gif, .pdf" />
                          <div class="flex-y-center gap-x-8" v-else-if="item.fieldType === 'upload' && item.fieldCode === 'underAgeFileUrl'">
                            <file-upload-new :disabled="readOnly" v-model="model.data[item.fieldCode]" accept=".jpg, .jpeg, .png, .gif, .pdf" />
                            <a-tooltip placement="right">
                              <a-icon type="question-circle" />
                              <template slot="title">
                                <span v-html="globalDataArray.siteTemplateLanguage.sign_birthday_file_template"></span>
                              </template>
                            </a-tooltip>
                          </div>
                          <file-upload-new :disabled="readOnly" v-else-if="item.fieldType === 'upload'" v-model="model.data[item.fieldCode]" />
                        </a-form-model-item>
                      </a-col>
                    </div>
                  </template>
                </div>

                <!-- 队员信息 -->
                <div class="addPrsonTemp" v-for="(mo, index) in model.temp" :key="`member-${index}`">
                  <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-show="index === 0 ? isShowLeader : true">
                    <div class="line"></div>
                  </a-col>

                  <template v-for="(item, itemIndex) in mo.teamList">
                    <div :key="`member-${index}-${item.fieldCode || item.fieldSort || itemIndex}`" v-if="item.isShow === '1' || item.isDoubleCheck">
                      <a-col :xs="24" :sm="24" :md="item.isStandalone === '0' ? 12 : 24" :lg="item.isStandalone === '0' ? 12 : 24" :xl="item.isStandalone === '0' ? 12 : 24">
                        <a-form-model-item
                          :label="item.fieldName" :prop="`temp.${index}.${item.fieldCode}`"
                          :disabled="readOnly"
                          :rules="buildFieldRules(item, 'member', index)"
                          :extra="item.prompt && item.prompt[0] ? item.prompt[0] : ''"
                        >
                          <!-- 生日选择框 -->
                          <a-date-picker
                            value-format="YYYY-MM-DD"
                            :locale="locale"
                            v-if="item.fieldCode === 'birthday'"
                            :disabled="readOnly"
                            v-model="mo[item.fieldCode]"
                            @change="onBirthdayChange($event, index)"
                          />

                          <!-- 下拉框 -->
                          <a-select
                            v-else-if="item.fieldCode === 'company' && item.isDoubleCheck"
                            :disabled="readOnly"
                            show-search
                            allow-clear
                            :filter-option="false"
                            :placeholder="pleaseSelect"
                            :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                            v-model="mo[item.fieldCode]"
                            @search="(value) => searchCollege1(value, index)"
                          >
                            <a-select-option v-for="(fi, collegeIndex) in mo.filterdCollegeList" :key="`member-${index}-${fi.identificationCode || collegeIndex}-${fi.name}`" :value="fi.name">
                              {{ fi.name }}
                            </a-select-option>
                          </a-select>
                          <a-select
                            :label-in-value="true"
                            :disabled="readOnly"
                            :placeholder="pleaseSelect"
                            v-else-if="item.fieldCode === 'countryCode'" @change="handleProvinceChange($event, index)"
                            v-model="mo[item.fieldCode]"
                            :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                          >
                            <a-select-option :value="po.parentId" v-for="po in item.list" :key="po.parentId">
                              {{ po.title }}
                            </a-select-option>
                          </a-select>
                          <a-select
                            :label-in-value="true"
                            :disabled="readOnly"
                            :placeholder="pleaseSelect"
                            v-else-if="item.fieldCode === 'cityCode'"
                            v-model="mo[item.fieldCode]"
                            :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                          >
                            <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                              {{ po.itemText }}
                            </a-select-option>
                          </a-select>
                          <a-select
                            :placeholder="pleaseSelect"
                            v-else-if="item.fieldType === 'select'"
                            :disabled="readOnly"
                            v-model="mo[item.fieldCode]"
                            :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                          >
                            <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                              {{ po.itemText }}
                            </a-select-option>
                          </a-select>
                          <!-- 普通输入框（带特殊日期框） -->
                          <a-input
                            @input="handleNumberInput($event, item.fieldCode, index)"
                            v-else-if="item.fieldType === 'text' && item.fieldCode === 'userPhone'"
                            :disabled="readOnly || item.readOnly"
                            v-model="mo[item.fieldCode]"
                          />
                          <a-input
                            v-else-if="item.fieldType === 'text'"
                            :disabled="readOnly || item.readOnly"
                            v-model="mo[item.fieldCode]"
                          />
                          <!-- 普通单选框 -->
                          <a-radio-group
                            v-else-if="item.fieldType === 'radio' && item.fieldCode === 'companyType'"
                            :disabled="readOnly"
                            @change="(e) => onChangeCompany1(e, index)"
                            v-model="mo[item.fieldCode]"
                          >
                            <a-radio :value="ca.itemValue" v-for="ca in item.list" :key="ca.itemValue">
                              {{ ca.itemText }}
                            </a-radio>
                          </a-radio-group>
                          <a-radio-group
                            v-else-if="item.fieldType === 'radio' && item.fieldCode === 'jobType'"
                            :disabled="readOnly"
                            @change="(e) => onChangeJob(e, index)"
                            v-model="mo[item.fieldCode]"
                          >
                            <a-radio :value="ca.itemValue" v-for="ca in item.list" :key="ca.itemValue">
                              {{ ca.itemText }}
                            </a-radio>
                          </a-radio-group>
                          <a-radio-group
                            v-else-if="item.fieldType === 'radio'"
                            :disabled="readOnly"
                            v-model="mo[item.fieldCode]"
                          >
                            <a-radio :value="ca.itemValue" v-for="ca in item.list" :key="ca.itemValue">
                              {{ ca.itemText }}
                            </a-radio>
                          </a-radio-group>

                          <!-- 文件上传 -->
                          <file-upload-new :disabled="readOnly" v-else-if="item.fieldType === 'upload' && item.fieldCode === 'studentUrl' " v-model="mo[item.fieldCode]" accept=".jpg, .jpeg, .png, .gif, .pdf" />
                          <div class="flex-y-center gap-x-8" v-else-if="item.fieldType === 'upload' && item.fieldCode === 'underAgeFileUrl'">
                            <file-upload-new :disabled="readOnly" v-model="mo[item.fieldCode]" accept=".jpg, .jpeg, .png, .gif, .pdf" />
                            <a-tooltip placement="right">
                              <a-icon type="question-circle" />
                              <template slot="title">
                                <span v-html="globalDataArray.siteTemplateLanguage.sign_birthday_file_template"></span>
                              </template>
                            </a-tooltip>
                          </div>
                          <file-upload-new :disabled="readOnly" v-else-if="item.fieldType === 'upload'" v-model="mo[item.fieldCode]" />
                        </a-form-model-item>
                      </a-col>
                    </div>
                  </template>

                  <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <a-button @click="delPerson(index)" v-if="!readOnly">
                      <a-icon type="minus" />
                      {{ globalDataArray.siteTemplateLanguage.del_team_member }}
                    </a-button>
                  </a-col>
                </div>
              </a-row>
              <a-button @click="addPerson()" v-if="!readOnly && isOverLimit">
                <a-icon type="plus" />
                {{ globalDataArray.siteTemplateLanguage.add_team_member }}
              </a-button>
            </a-form-model>
          </div>
        </div>
        <div class="btnBox fnt_18" v-if="!readOnly">
          <div class="btn btn1" :class="{ 'btn-disabled': submitting || !formReady }" @click="confirmImpEdit">{{ subButton }}</div>
          <div class="btn btn2" :class="{ 'btn-disabled': submitting }" @click="cancelImpEdit">{{ globalDataArray.siteTemplateLanguage.cancel }}</div>
        </div>
        <div class="close" :class="{ 'btn-disabled': submitting }" @click="cancelImpEdit1"></div>
      </div>
    </div>
  </div>
</template>

<script>
import FileUploadNew from '@/views/person/component/FileUploadNew.vue'
import {
  boolAuth,
  competitionSub,
  getCollegeList,
  getGroupList,
  queryByParentId,
  verifyTwo,
  verifyUserInfo
} from '@/api/saiti'
import { getCityList, getCompetitionDict, getProvinceList } from '@/api/api'
import debounce from 'lodash/debounce'
import { deleteMember, threeVerification, verifyUserInfo1 } from '@/api/person/person'
import { Modal, message } from 'ant-design-vue'
import zhCN from 'ant-design-vue/es/date-picker/locale/zh_CN'
import enUS from 'ant-design-vue/es/date-picker/locale/en_US'
import moment from 'moment'
import 'moment/locale/zh-cn'

export default {
  name: 'FormsignNew',
  components: { FileUploadNew },
  props: {
    formsign: {
      type: Boolean,
      default: false
    },
    titleName: {
      type: String,
      default: ''
    },
    subButton: {
      type: String,
      default: ''
    },
    curInfoArray: {
      type: Object,
      default: () => ({})
    },
    personList: {
      type: Object,
      default: () => ({})
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    this.searchCollege = debounce(this.searchCollege, 800)
    this.searchCollege1 = debounce(this.searchCollege1, 800)

    return {
      mobileNumberRule: '',
      studentInfo: {},
      model: {
        data: {
          categoryCompId: [],
          categoryId: '',
          competitionId: '',
          nation: '',
          teamName: '',
          teamType: '',
          companyType: '',
          jobType: '',
          language: '',
          countryCode: '',
          grade: '',
          cityCode: ''
        },
        temp: []
      },
      globalLanguage: this.globalDataArray.siteInfo.language,
      provinceList: [], // 省份列表
      allList: [], // 全部字段信息
      columnList: [], // 团队字段信息
      showList: [], // 队长字段信息
      teamMemberList: [], // 队员字段信息
      dictCodeArray: [], // 字典值数组
      verify: {}, // 是否开启验证
      limitNum: 0, // 限制队员数量
      filterdCollegeList: [], // 缓存学校
      groupArray: [], // 组别列表
      isShowLeader: true, // 是否显示队长信息
      staging: {}, // 暂存对象
      originalTeamEmails: new Set(), // 团队原始邮箱快照（队内迁移感知，避免互换邮箱被外部查重误报）
      originalTeamPhones: new Set(), // 团队原始手机号快照（队内迁移感知，避免互换手机号被外部查重误报）
      collegeList: [], // 学院列表
      submitting: false, // 提交状态，防重提交
      formReady: false, // 表单是否渲染完成
      locale: this.globalDataArray.siteInfo.language == 'zh_CN' ? zhCN : enUS,
      moment
    }
  },
  computed: {
    isOverLimit() {
      return this.limitNum > this.model.temp.length + 1
    },
    pleaseSelect() {
      return this.globalDataArray.siteTemplateLanguage.please_select
    },
    pleaseInput() {
      return this.globalDataArray.siteTemplateLanguage.please_enter
    }
  },
  watch: {
    formsign: {
      immediate: true,
      async handler(val) {
        if (val) {
          // 开始加载，重置状态
          this.submitting = false
          this.formReady = false
          // 重置团队原始联系方式快照（新建模式下保持为空，编辑模式由 edit() 重建）
          this.originalTeamEmails = new Set()
          this.originalTeamPhones = new Set()

          try {
            if (this.$refs.realForm) {
              this.$refs.realForm.resetFields()
            }
            await this.initDictFun()
            if (this.personList && Object.keys(this.personList).length !== 0) {
              this.edit()
            }

            // 表单加载完成
            this.formReady = true
          } catch (error) {
            console.error('表单初始化失败:', error)
            this.formReady = false
          }
        } else {
          // 关闭弹窗，重置状态
          this.submitting = false
          this.formReady = false
        }
      }
    }
  },
  methods: {
    // 构建字段验证规则（统一管理 required / trigger / 校验器）
    buildFieldRules(item, section, memberIndex) {
      // 选择类字段（单选、下拉、日期）使用 change 触发 + "请选择" 前缀
      const isSelectLike = item.fieldType === 'radio' || item.fieldType === 'select' || item.fieldCode === 'birthday'
      const trigger = isSelectLike ? 'change' : 'blur'
      const prefix = isSelectLike ? this.pleaseSelect : this.pleaseInput
      const message = prefix + item.fieldName + '!'

      // 省市字段：仅需必填规则，无需额外校验
      if (item.fieldCode === 'countryCode' || item.fieldCode === 'cityCode') {
        return [{ required: item.verificationType, message, trigger }]
      }

      // 确定必填值：队员使用 getFieldRequired，队长/团队使用 shouldFieldBeRequired
      const required = section === 'member'
        ? this.getFieldRequired(item, memberIndex)
        : this.shouldFieldBeRequired(item)

      const rules = [{ required, message, trigger }]

      // 联系方式校验（邮箱/手机）
      const context = section === 'member' ? memberIndex : (section === 'team' ? '-2' : '-1')
      const isContactField = item.verificationType === 'email' || item.verificationType === 'phone' ||
        item.fieldCode === 'userMail' || item.fieldCode === 'userPhone' ||
        (section === 'team' && (item.fieldCode === 'userMailNew' || item.fieldCode === 'userPhoneNew'))

      rules.push({
        validator: isContactField
          ? (rule, value, callback) => this.validateContactInfo(rule, value, callback, item, context)
          : undefined,
        trigger: 'blur'
      })

      // 队内唯一校验：队长↔队员、队员↔队员 联系方式归一化比对（本地判断，不发后端请求）
      if (isContactField) {
        rules.push({
          validator: (rule, value, callback) => this.validateTeamUnique(rule, value, callback, item, context),
          trigger: 'blur'
        })
      }

      // 身份证校验
      rules.push({
        validator: item.verificationType === 'idCard'
          ? (rule, value, callback) => this.validateID(rule, value, callback, context)
          : undefined,
        trigger: 'blur'
      })

      return rules
    },

    // 邮箱归一化：trim + 转小写
    normalizeEmail(v) {
      if (v === undefined || v === null) return ''
      return String(v).trim().toLowerCase()
    },

    // 手机号归一化：仅保留数字，去掉前导 86
    normalizePhone(v) {
      if (v === undefined || v === null) return ''
      let s = String(v).replace(/[^\d]/g, '')
      if (s.length > 11 && s.startsWith('86')) s = s.slice(2)
      return s
    },

    // 构建团队原始联系方式快照（进入编辑时调用，用于队内迁移感知）
    buildOriginalContactSnapshot() {
      const emails = new Set()
      const phones = new Set()
      const collect = (mail, phone) => {
        const em = this.normalizeEmail(mail)
        const ph = this.normalizePhone(phone)
        if (em) emails.add(em)
        if (ph) phones.add(ph)
      }
      if (this.personList && this.personList.records && Array.isArray(this.personList.records)) {
        this.personList.records.forEach(r => collect(r.userMail, r.userPhone))
      } else if (this.personList && Object.keys(this.personList).length !== 0) {
        collect(this.personList.userMail, this.personList.userPhone)
        ;(this.personList.temp || []).forEach(m => collect(m.userMail, m.userPhone))
      }
      this.originalTeamEmails = emails
      this.originalTeamPhones = phones
    },

    // 队内联系方式唯一校验（队长↔队员、队员↔队员，归一化比对，本地判断）
    validateTeamUnique(rule, value, callback, item, context) {
      if (!value || !String(value).trim()) {
        callback()
        return
      }
      const isPhone = item.verificationType === 'phone' || item.fieldCode === 'userPhone' || item.fieldCode === 'userPhoneNew'
      const normalized = isPhone ? this.normalizePhone(value) : this.normalizeEmail(value)
      if (!normalized) {
        callback()
        return
      }

      const isLeaderSelf = context === '-1' || context === '-2'
      const others = []
      // 队长/团队信息块的联系方式（自己不是队长时纳入比对）
      if (!isLeaderSelf) {
        others.push(isPhone ? this.model.data.userPhone : this.model.data.userMail)
      }
      // 全部队员（排除自己）
      ; (this.model.temp || []).forEach((m, i) => { // eslint-disable-line no-extra-semi
        if (!isLeaderSelf && String(context) === String(i)) return
        others.push(isPhone ? m.userPhone : m.userMail)
      })

      const dup = others.some(raw => {
        const n = isPhone ? this.normalizePhone(raw) : this.normalizeEmail(raw)
        return n && n === normalized
      })
      if (dup) {
        callback(new Error(this.globalDataArray.siteTemplateLanguage.team_contact_duplicate || '该联系方式与队内其他成员重复'))
      } else {
        callback()
      }
    },

    // 判断是否为青少年模板
    isYouthTemplate() {
      // 检查模板中是否有 grade 字段且是显示的
      const gradeField = this.allList.find(item =>
        item.fieldCode === 'grade' && item.isShow === '1'
      )

      return !!gradeField
    },

    // 专门用于队员信息的必填判断
    getFieldRequired(item, memberIndex) {
      // console.log('=== getFieldRequired 队员字段必填判断 ===')
      // console.log('字段代码:', item.fieldCode, '队员索引:', memberIndex)
      // console.log('model.temp:', this.model.temp)

      // 职业类型字段始终必填
      if (item.fieldCode === 'jobType') {
        return true
      }

      // 未成年附件字段：仅在显示时必填（由生日联动控制显示）
      if (item.fieldCode === 'underAgeFileUrl') {
        return true
      }

      // 邮箱字段按照正常逻辑处理，不做语言区分
      if (['userMail', 'userMailNew'].includes(item.fieldCode)) {
        console.log('邮箱字段，使用原逻辑:', item.verificationType)
        return item.verificationType
      }

      // 如果不是手机号或身份证字段，按原逻辑处理
      if (!['userPhone', 'userPhoneNew', 'idCard'].includes(item.fieldCode) && item.verificationType !== 'phone' && item.verificationType !== 'idCard') {
        console.log('非手机号/身份证字段，使用原逻辑:', item.verificationType)
        return item.verificationType
      }

      // 获取队员的语言信息（针对手机号和身份证字段）
      let memberLanguage = null

      // 优先从model.temp获取语言信息（支持新添加的队员）
      if (this.model.temp && this.model.temp[memberIndex]) {
        memberLanguage = this.model.temp[memberIndex].language
        console.log('从model.temp获取队员语言:', memberLanguage)
      }

      // 如果没有获取到语言，从personList.records中获取（编辑现有队员）
      if (!memberLanguage && this.personList && this.personList.records && Array.isArray(this.personList.records)) {
        const memberRecords = this.personList.records.filter(record => record.isCaptain !== 1)
        if (memberRecords[memberIndex]) {
          memberLanguage = memberRecords[memberIndex].language
          console.log('从personList.records获取队员语言:', memberLanguage)
        }
      }

      // 只有中文用户的手机号和身份证字段才显示为必填
      if (memberLanguage && memberLanguage.toLowerCase() === 'zh_cn') {
        console.log('队员是中文用户，手机号/身份证字段显示为必填')
        return item.verificationType || ['userPhone', 'userPhoneNew', 'idCard'].includes(item.fieldCode) || item.verificationType === 'phone' || item.verificationType === 'idCard'
      }

      console.log('队员是非中文用户，手机号/身份证字段不显示为必填')
      return false
    },

    // 判断字段是否应该显示为必填
    shouldFieldBeRequired(item, memberIndex = null) {
      // console.log('=== shouldFieldBeRequired 开始执行 ===')
      // console.log('字段代码:', item.fieldCode, '队员索引:', memberIndex)

      // 职业类型字段始终必填
      if (item.fieldCode === 'jobType') {
        return true
      }

      // 未成年附件字段：仅在显示时必填（由生日联动控制显示）
      if (item.fieldCode === 'underAgeFileUrl') {
        return true
      }

      // 邮箱字段按照正常逻辑处理，不做语言区分
      if (['userMail', 'userMailNew'].includes(item.fieldCode)) {
        return item.verificationType
      }

      // 如果不是手机号或身份证字段，按原逻辑处理
      if (!['userPhone', 'userPhoneNew', 'idCard'].includes(item.fieldCode) && item.verificationType !== 'phone' && item.verificationType !== 'idCard') {
        return item.verificationType
      }

      // 对于联系方式字段，需要根据语言状态判断
      let language = null

      // 如果是队员信息，根据队员的语言状态判断
      if (memberIndex !== null && this.personList && this.personList.records && Array.isArray(this.personList.records)) {
        // 找到非队长的记录，按索引匹配
        const memberRecords = this.personList.records.filter(record => record.isCaptain !== 1)
        const memberRecord = memberRecords[memberIndex]

        // console.log(`shouldFieldBeRequired 队员${memberIndex} - memberRecords:`, memberRecords)
        // console.log(`shouldFieldBeRequired 队员${memberIndex} - memberRecord:`, memberRecord)

        if (memberRecord) {
          language = memberRecord.language
          // console.log(`shouldFieldBeRequired 队员${memberIndex}的语言:`, language, `字段代码:`, item.fieldCode)
          if (!language && memberRecord.sigupJson) {
            try {
              const signupData = JSON.parse(memberRecord.sigupJson)
              language = signupData.language || signupData.currentLanguge
              // console.log(`shouldFieldBeRequired 从sigupJson解析的语言:`, language)
            } catch (e) {
              // console.log('解析队员 sigupJson 失败:', e)
            }
          }
        } else {
          // console.log(`shouldFieldBeRequired 找不到队员${memberIndex}的记录`)
        }
      }

      // 如果没有获取到队员的语言，使用队长的语言
      if (!language && this.personList && Object.keys(this.personList).length !== 0) {
        language = this.personList.language

        // 如果 personList 包含 records 数组（团队信息列表）
        if (this.personList.records && Array.isArray(this.personList.records)) {
          // 从第一条记录中获取语言信息（通常队长的记录）
          const captainRecord = this.personList.records.find(record => record.isCaptain === 1)
          if (captainRecord) {
            language = captainRecord.language
          } else if (this.personList.records.length > 0) {
            language = this.personList.records[0].language
          }
        }

        // 如果 language 为空但从 sigupJson 中可以解析出语言信息
        if (!language && this.personList.sigupJson) {
          try {
            const signupData = JSON.parse(this.personList.sigupJson)
            language = signupData.language || signupData.currentLanguge
          } catch (e) {
            console.log('解析 sigupJson 失败:', e)
          }
        }
      }

      // 新建场景：检查当前语言环境
      if (!language && this.curInfoArray && this.curInfoArray.currentLanguge) {
        language = this.curInfoArray.currentLanguge
      }

      // 也检查全局语言设置
      if (!language) {
        language = this.globalLanguage
      }

      // 只有当语言是中文(zh_CN)时，手机号和身份证字段才显示为必填
      if (language && language.toLowerCase() === 'zh_cn') {
        // console.log(`shouldFieldBeRequired 最终判断: 中文用户 ${language}，字段 ${item.fieldCode} 显示为必填`)
        return item.verificationType || ['userPhone', 'userPhoneNew', 'idCard'].includes(item.fieldCode) || item.verificationType === 'phone' || item.verificationType === 'idCard'
      }

      // 非中文状态下，手机号和身份证字段不显示为必填
      // console.log(`shouldFieldBeRequired 最终判断: 非中文用户 ${language}，字段 ${item.fieldCode} 不显示为必填`)
      return false
    },

    // 判断队员是否需要验证手机号码
    shouldValidatePhoneForMember(memberIndex) {
      // 获取队员的语言状态
      let language = null

      // 优先从model.temp获取语言信息（支持新添加的队员）
      if (this.model.temp && this.model.temp[memberIndex]) {
        language = this.model.temp[memberIndex].language
        console.log(`从model.temp获取队员${memberIndex}的语言:`, language)
      }

      // 如果没有获取到语言，从personList.records中获取（编辑现有队员）
      if (!language && this.personList && this.personList.records && Array.isArray(this.personList.records)) {
        // 找到非队长的记录，按索引匹配
        const memberRecords = this.personList.records.filter(record => record.isCaptain !== 1)
        const memberRecord = memberRecords[memberIndex]

        if (memberRecord) {
          language = memberRecord.language
          console.log(`从personList.records获取队员${memberIndex}的语言:`, language, '完整记录:', memberRecord)
          if (!language && memberRecord.sigupJson) {
            try {
              const signupData = JSON.parse(memberRecord.sigupJson)
              language = signupData.language || signupData.currentLanguge
              console.log(`从sigupJson解析的语言:`, language)
            } catch (e) {
              console.log('解析队员 sigupJson 失败:', e)
            }
          }
        } else {
          console.log(`找不到队员${memberIndex}的记录，memberRecords:`, memberRecords)
        }
      }

      // 如果还是没有获取到队员的语言，则不进行验证（安全策略）
      if (!language) {
        console.log(`队员${memberIndex}没有获取到语言，跳过验证`)
        return false
      }

      // 只有当语言是中文(zh_CN)时，才验证手机号码
      if (language && language.toLowerCase() === 'zh_cn') {
        console.log(`队员${memberIndex}是中文状态(${language})，需要验证手机号码`)
        return true
      }

      // 非中文状态下，不验证手机号码
      console.log(`队员${memberIndex}是非中文状态(${language})，不验证手机号码`)
      return false
    },

    // 判断是否需要验证手机号码
    shouldValidatePhone() {
      // 如果是编辑模式且有 personList 数据
      if (this.personList && Object.keys(this.personList).length !== 0) {
        let language = this.personList.language

        // 如果 personList 包含 records 数组（团队信息列表）
        if (this.personList.records && Array.isArray(this.personList.records)) {
          // 从第一条记录中获取语言信息（通常队长的记录）
          const captainRecord = this.personList.records.find(record => record.isCaptain === 1)
          if (captainRecord) {
            language = captainRecord.language
          } else if (this.personList.records.length > 0) {
            language = this.personList.records[0].language
          }
        }

        // 只有当语言是中文(zh_CN)时，才验证手机号码
        if (language && language.toLowerCase() === 'zh_cn') {
          return true
        }

        // 如果 language 为空但从 sigupJson 中可以解析出语言信息
        if (!language && this.personList.sigupJson) {
          try {
            const signupData = JSON.parse(this.personList.sigupJson)
            const jsonLanguage = signupData.language
            if (jsonLanguage && jsonLanguage.toLowerCase() === 'zh_cn') {
              return true
            }
          } catch (e) {
            // console.log('解析 sigupJson 失败:', e)
          }
        }

        // 如果是单条记录但没有直接的language字段，从sigupJson解析
        if (!language && this.personList.sigupJson) {
          try {
            const signupData = JSON.parse(this.personList.sigupJson)
            if (signupData.currentLanguge && signupData.currentLanguge.toLowerCase() === 'zh_cn') {
              return true
            }
          } catch (e) {
            console.log('解析 sigupJson 失败:', e)
          }
        }
      }

      // 新建场景：检查当前语言环境
      if (this.curInfoArray && this.curInfoArray.currentLanguge) {
        const currentLang = this.curInfoArray.currentLanguge
        // 只有当前语言是中文(zh_CN)时，才验证手机号码
        if (currentLang && currentLang.toLowerCase() === 'zh_cn') {
          return true
        }
      }

      // 也检查全局语言设置
      if (this.globalLanguage && this.globalLanguage.toLowerCase() === 'zh_cn') {
        return true
      }

      // 默认不进行验证（非中文情况）
      return false
    },
    edit() {
      // console.log(this.personList, 'this.personList')
      // console.log('编辑模式 - personList.records:', this.personList.records)
      // 构建团队原始联系方式快照（用于队内迁移感知，避免互换邮箱/手机号被外部查重误报）
      this.buildOriginalContactSnapshot()
      if (this.personList.grade) {
        this.onChangeGroupId(this.personList.groupId)
      }
      if (this.personList.teamType === '02') {
        this.columnList.forEach(colItem => {
          if (colItem.fieldCode === 'fileUrl') {
            colItem.isShow = '1'
          }
        })
      }
      if (this.personList.jobType === '02' && this.personList.companyType === '02') {
        this.showList.forEach(colItem => {
          if (colItem.fieldCode === 'educational') {
            colItem.isShow = '1'
          }
          if (colItem.fieldCode === 'studentUrl') {
            colItem.isShow = '1'
          }
          if (colItem.fieldCode === 'onlineCode') {
            colItem.isShow = '1'
          }
        })
      }
      this.showList.forEach(colItem => {
        if (colItem.fieldCode === 'leaderName') {
          colItem.readOnly = true
        }
        if (colItem.fieldCode === 'userPhone') {
          colItem.readOnly = true
        }
      })
      if (this.personList.temp) {
        this.personList.temp.forEach(item => {
          item.teamList = structuredClone(this.teamMemberList)
        })
      }
      this.personList?.temp.forEach((item, index) => {
        if (item.jobType === '02' && item.companyType === '02') {
          item.teamList.forEach(teamItem => {
            if (teamItem.fieldCode === 'educational') {
              teamItem.isShow = '1'
            }
            if (teamItem.fieldCode === 'studentUrl') {
              teamItem.isShow = '1'
            }
            if (teamItem.fieldCode === 'onlineCode') {
              teamItem.isShow = '1'
            }
          })
        }
        if (item.companyType) {
          const index = item.teamList.findIndex(teamItem => teamItem.fieldCode === 'companyType' && teamItem.isShow === '1')
          item.teamList.forEach(teamItem => {
            if (teamItem.fieldCode === 'company' && index !== -1) {
              teamItem.isShow = '1'
            }
          })
        }
        item.teamList.forEach(teamItem => {
          if (teamItem.fieldCode === 'userName') {
            teamItem.readOnly = true
          }
          if (teamItem.fieldCode === 'userPhone') {
            teamItem.readOnly = true
          }
        })
      })
      if (this.personList.companyType) {
        const index = this.showList.findIndex(item => item.fieldCode === 'companyType' && item.isShow === '1')
        this.showList.forEach(item => {
          if (item.fieldCode === 'company' && index !== -1) {
            item.isShow = '1'
          }
        })
      }
      // 如果有records数组，需要分离队长和队员数据
      if (this.personList.records && Array.isArray(this.personList.records)) {
        // 找到队长数据
        const captainRecord = this.personList.records.find(record => record.isCaptain === 1)
        if (captainRecord) {
          this.model.data = structuredClone(captainRecord)
        }

        // 找到队员数据并构建temp数组
        const memberRecords = this.personList.records.filter(record => record.isCaptain !== 1)
        this.model.temp = memberRecords.map(memberRecord => {
          const tempItem = structuredClone(memberRecord)
          tempItem.teamList = structuredClone(this.teamMemberList)
          return tempItem
        })

        console.log('编辑模式 - 队长数据:', this.model.data)
        console.log('编辑模式 - 队员数据:', this.model.temp)
      } else {
        // 原有的逻辑，用于兼容其他数据格式
        this.model.data = structuredClone(this.personList)
        this.model.temp = structuredClone(this.personList.temp || [])
      }

      if (!this.model.data.teamName) {
        this.isShowLeader = false
      }
      console.log(this.model, 'this.model')

      // 检查生日，控制未成年附件字段显示
      if (this.model.data.birthday) {
        this.toggleUnderAgeFileUrl('-1', this.isUnderAge(this.model.data.birthday))
      }
      this.model.temp.forEach((member, index) => {
        if (member.birthday) {
          this.toggleUnderAgeFileUrl(index, this.isUnderAge(member.birthday))
        }
      })

      // 编辑模式下，如果省份有值，主动加载城市数据
      this.$nextTick(() => {
        this.loadCityDataIfProvinceExists()
      })
    },
    // 初始化数据
    async initDictFun() {
      this.limitNum = this.curInfoArray.teamsUsers
      await this.getCollegeList()
      await this.getGroupList()
      const res = await getProvinceList()
      if (res.success) {
        this.provinceList = res.result // 省或国家列表
      }
      // 获取报名模板
      await this.findAllColunm()
      // 获取是否开启验证
      const params = 'language=' + this.globalLanguage + '&competitionId=' + this.curInfoArray.competitionId
      const boolAuthRes = await boolAuth(params)
      if (boolAuthRes.success) {
        this.verify = boolAuthRes.result
      }
    },
    async findAllColunm() {
      const paTemp = 'language=' + this.globalLanguage + '&templateId=' + this.curInfoArray.templateId
      const res = await queryByParentId(paTemp)
      if (res.success) {
        // 全部字段信息
        this.allList = JSON.parse(res.result.fieldJson)
        // 获取所有字典值
        this.allList.forEach(item => {
          // 检查 item 中是否有 dictCode 属性
          if (item.dictCode) {
            // 将 dictCode 数据添加到数组中
            this.dictCodeArray.push(item.dictCode)
          }
          if (item.defaultValue) {
            this.staging[item.fieldCode] = item.defaultValue
          }
        })
        this.model.data = { ...this.model.data, ...this.staging }
        await this.findDictCode()
      }
    },
    // 给字段值绑定字典列表
    async findDictCode() {
      const param = 'dictCode=' + this.dictCodeArray.join(',') + ',mobile_number'
      const res = await getCompetitionDict(param)
      if (res.success) {
        const dictCodeList = res.result
        dictCodeList.forEach(item => {
          if (item.dictCode === 'mobile_number') {
            this.mobileNumberRule = item.list[0]?.itemValue
          }
        })
        this.allList = this.allList.map(showItem => {
          const dictItem = dictCodeList.find(dictItem => dictItem.dictCode === showItem.dictCode)
          if (dictItem) {
            showItem.list = dictItem.list
          }
          if (showItem.fieldCode === 'countryCode') {
            showItem.list = this.provinceList
          }
          if (showItem.fieldCode === 'groupId') {
            showItem.list = this.groupArray
          }
          return showItem
        })
        this.columnList = this.allList.filter(item => item.isTeam === 1)
        this.showList = this.allList.filter(item => item.isTeam === 0)
        const teamMemberListCopy = JSON.parse(JSON.stringify(this.showList))
        teamMemberListCopy.forEach(item => {
          if (item.fieldCode === 'leaderName') {
            item.fieldName = this.globalDataArray.siteTemplateLanguage.team_member_name
            item.fieldCode = 'userName'
          }
        })
        this.teamMemberList = teamMemberListCopy

        // 初始化：隐藏未成年附件字段（由生日联动控制显示）
        this.showList.forEach(item => {
          if (item.fieldCode === 'underAgeFileUrl') {
            item.isShow = '0'
          }
        })
        this.teamMemberList.forEach(item => {
          if (item.fieldCode === 'underAgeFileUrl') {
            item.isShow = '0'
          }
        })
        console.log(this.columnList, 'lllll')
        console.log(this.showList, 'mmmmmm')
        console.log(this.teamMemberList, 'zzzzz')
      }
    },
    confirmImpEdit() {
      // 防重提交和表单状态检查
      if (this.submitting) {
        return
      }

      if (!this.formReady) {
        return
      }

      if (this.readOnly) {
        this.cancelImpEdit()
        return
      }

      // 立即设置提交状态，防止快速点击
      this.submitting = true

      // 保存原始的 countryCode 和 cityCode 对象，用于提交失败后恢复
      const originalCountryCode = this.model.data.countryCode
      const originalCityCode = this.model.data.cityCode
      const originalTempData = structuredClone(this.model.temp)

      this.$refs['realForm'].validate(async (err, valid) => {
        const validMembers = this.getValidMembers(this.model.temp)
        if (err) {
          try {
          // console.log(this.model, 'this.model.data')
            const data = this.model.data
            // console.log(data)
            const subData = []
            const curInfoArray = this.curInfoArray
            /*          Object.keys(curInfoArray).forEach(key => {
            if (data[key] === undefined || data[key] === null) {
              data[key] = curInfoArray[key]
            }
          })*/
            data.templateId = this.curInfoArray.templateId
            data.parentId = this.curInfoArray.parentId
            data.currentLanguge = this.curInfoArray.currentLanguge
            data.teamsUsers = this.curInfoArray.teamsUsers
            data.teams = this.curInfoArray.teams
            data.categoryId = this.curInfoArray.categoryId
            data.competitionId = this.curInfoArray.competitionId
            data.inviteId = this.curInfoArray.inviteId
            data.zoneId = this.curInfoArray.zoneId
            data.teamNo = this.curInfoArray.teamNo

            if (data.countryCode?.key) {
              const countryKL = data.countryCode
              data['countryCode'] = countryKL.key
              data['countryName'] = countryKL.label
            } else {
              data['countryCode'] = ''
              data['countryName'] = ''
            }

            if (data.cityCode?.key) {
              const countryKL = data.cityCode
              data['cityCode'] = countryKL.key
              data['cityName'] = countryKL.label
            } else {
              data['cityCode'] = ''
              data['cityName'] = ''
            }
            if (data.leaderNameNew) {
              data['leaderName'] = data.leaderNameNew
              data['userMail'] = data.userMailNew
              data['userPhone'] = data.userPhoneNew
            }
            data['userName'] = data.leaderName

            this.model.data['isCaptain'] = 1
            delete data.sigupJson
            data.sigupJson = JSON.stringify(data)
            subData.push(data)

            validMembers.forEach((item, index) => {
              item['categoryId'] = this.curInfoArray.categoryId
              item['competitionId'] = this.curInfoArray.competitionId
              item['zoneId'] = this.curInfoArray.zoneId
              item['templateId'] = this.curInfoArray.templateId
              item['parentId'] = this.curInfoArray.parentId
              item['teamsUsers'] = this.curInfoArray.teamsUsers
              item['teams'] = this.curInfoArray.teams
              item['currentLanguge'] = this.curInfoArray.currentLanguge
              if (item.countryCode?.key) {
                const countryKL = item.countryCode
                item['countryCode'] = countryKL.key
                item['countryName'] = countryKL.label
              } else {
                item['countryCode'] = ''
                item['countryName'] = ''
              }
              if (item.cityCode?.key) {
                const countryKL = item.cityCode
                item['cityCode'] = countryKL.key
                item['cityName'] = countryKL.label
              } else {
                item['cityCode'] = ''
                item['cityName'] = ''
              }
              item['leaderName'] = data.userName
              item['isCaptain'] = 0
              item['teamName'] = data['teamName']
              item['teamType'] = data['teamType']
              item['teamNo'] = data['teamNo']
              subData.push(item)
            })
            const paramsNew = structuredClone(subData)
            paramsNew.forEach(item => {
              if (item.isCaptain === 0) {
                delete item.teamList
                delete item.filerdCollegeList
                item.sigupJson = JSON.stringify(item)
              }
            })
            console.log(paramsNew, 'paramsNew')
            console.log(subData, 'subData')
            const res = await competitionSub(paramsNew)
            if (res.success) {
              this.$emit('itemclick', '1', this.curInfoArray) // itemclick  为事件名
              this.$emit('update:formsign', false)
              if (window._oafs) {
                window._oafs.action('报名成功', {
                  comId: paramsNew[0].competitionId
                })
              }
              this.model.data = {}
              if (this.personList && Object.keys(this.personList).length !== 0) {
                this.$emit('SignupRecordList')
              }
              if (data.id) {
                this.$message.success(res.result)
              }
            } else {
              // 提交失败，恢复原始的 countryCode 和 cityCode 对象
              this.model.data.countryCode = originalCountryCode
              this.model.data.cityCode = originalCityCode
              this.model.temp = originalTempData

              if (res.code == '403') {
                message.error(res.message)
              }
            }
          } catch (error) {
            console.error('提交失败:', error)
            this.$message.error('提交失败，请稍后重试')

            // 发生异常时也恢复原始数据
            this.model.data.countryCode = originalCountryCode
            this.model.data.cityCode = originalCityCode
            this.model.temp = originalTempData
          } finally {
          // 重置提交状态
            this.submitting = false
          }
        } else {
          // 验证失败，重置提交状态
          this.submitting = false
          return false
        }
      })
    },
    cancelImpEdit() {
      // 提交中时阻止取消
      if (this.submitting) {
        return
      }

      this.model = {
        data: {
          categoryCompId: [],
          categoryId: '',
          competitionId: '',
          nation: '',
          teamName: '',
          teamType: '',
          companyType: '',
          jobType: '',
          language: '',
          countryCode: '',
          cityCode: ''
        },
        temp: []
      }
      this.showList = []
      this.columnList = []
      this.teamMemberList = []
      this.submitting = false
      this.formReady = false
      this.$emit('itemclick', '2') // itemclick  为事件名
      this.$emit('update:formsign', false)
    },
    cancelImpEdit1() {
      // 提交中时阻止取消
      if (this.submitting) {
        return
      }

      this.model = {
        data: {
          categoryCompId: [],
          categoryId: '',
          competitionId: '',
          nation: '',
          teamName: '',
          teamType: '',
          companyType: '',
          jobType: '',
          language: '',
          countryCode: '',
          cityCode: ''
        },
        temp: []
      }
      this.showList = []
      this.columnList = []
      this.teamMemberList = []
      this.submitting = false
      this.$emit('itemclick', '3') // itemclick  为事件名
      this.$emit('update:formsign', false)
    },
    getValidMembers(members) {
      if (!Array.isArray(members)) {
        return []
      }
      return members.filter(member => this.shouldKeepMember(member))
    },
    shouldKeepMember(member) {
      if (!member) {
        return false
      }
      const fields = ['userName', 'userPhone', 'userMail', 'memberId']
      return fields.some(field => {
        const value = member[field]
        if (typeof value === 'string') {
          return value.trim() !== ''
        }
        return value !== undefined && value !== null
      })
    },
    // 切换团队类型
    onChangeFieldType(e) {
      console.log(e)
      const newValue = e.target.value === '02' ? '1' : '0'
      this.columnList.forEach(item => {
        if (item.fieldCode === 'fileUrl') {
          item.isShow = newValue
        }
      })
    },
    getVerificationIdCard(k) {
      if (k === '-1' || k === '-2') {
        return this.model.data.idCard
      }
      return this.model.temp?.[k]?.idCard
    },

    shouldRunTwoFactorVerification(k) {
      if (!this.verify.bootTwo) {
        return false
      }
      if (!this.verify.boolThree) {
        return true
      }
      const idCard = this.getVerificationIdCard(k)
      return !idCard || String(idCard).trim() === ''
    },

    validateContactInfo(rule, value, callback, item, k) {
      // 如果值为空，直接通过验证（适用于英文用户不需要填写联系方式的情况）
      if (!value || value.trim() === '') {
        callback()
        return
      }

      // 根据验证类型进行格式验证
      if (item.verificationType === 'email' || item.fieldCode === 'userMail' || item.fieldCode === 'userMailNew') {
        // 邮箱格式验证
        // 更严格的邮箱格式正则表达式
        const emailRegex = /^[a-zA-Z0-9]([a-zA-Z0-9._-])*[a-zA-Z0-9]@[a-zA-Z0-9]([a-zA-Z0-9.-])*[a-zA-Z0-9]\.[a-zA-Z]{2,}$/

        // 基本格式验证
        if (!emailRegex.test(value.trim())) {
          callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
          return
        }

        // 额外的格式限制检查
        const trimmedValue = value.trim()

        // 检查连续的点号
        if (trimmedValue.includes('..')) {
          callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
          return
        }

        // 检查邮箱长度（总长度不超过254字符，本地部分不超过64字符）
        if (trimmedValue.length > 254) {
          callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
          return
        }

        const [localPart, domainPart] = trimmedValue.split('@')
        if (localPart.length > 64) {
          callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
          return
        }

        // 检查域名部分是否过长
        if (domainPart && domainPart.length > 253) {
          callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
          return
        }
      } else if (item.verificationType === 'phone' || item.fieldCode === 'userPhone' || item.fieldCode === 'userPhoneNew') {
        // 手机号格式验证
        // 检查是否需要验证手机号（只有中文用户才验证）
        let shouldValidate = false
        if (k === '-1' || k === '-2') {
          shouldValidate = this.shouldValidatePhone()
        } else {
          shouldValidate = this.shouldValidatePhoneForMember(k)
        }

        // 如果不需要验证（非中文用户），直接通过
        if (!shouldValidate) {
          callback()
          return
        }

        // 使用动态的mobileNumberRule进行格式验证
        if (this.mobileNumberRule) {
          const regID = new RegExp(this.mobileNumberRule.replace(/^\/|\/$/g, ''))
          if (!regID.test(value)) {
            callback(new Error('请输入正确的手机号格式 '))
            return
          }
        } else {
          // 如果没有获取到规则，使用默认规则
          const regID = new RegExp(/^[0-9-+]+$/)
          if (!regID.test(value)) {
            callback(new Error('请输入正确的手机号格式 '))
            return
          }
        }
      }

      // 队员手机号/邮箱不能与登录用户（队长）相同
      const isEmailField = item.verificationType === 'email' || item.fieldCode === 'userMail' || item.fieldCode === 'userMailNew'
      const isPhoneField = item.verificationType === 'phone' || item.fieldCode === 'userPhone' || item.fieldCode === 'userPhoneNew'
      if (isEmailField && this.isMemberContactSameAsLoginUser(value, 'email', k)) {
        callback(new Error(this.getMemberLoginConflictMessage()))
        return
      }
      if (isPhoneField && this.isMemberContactSameAsLoginUser(value, 'phone', k)) {
        callback(new Error(this.getMemberLoginConflictMessage()))
        return
      }

      // 格式验证通过，继续进行重复性验证
      let param = {}
      if (k === '-1') {
        param = {
          id: this.model.data.id,
          name: this.model.data.leaderName,
          phone: this.model.data.userPhone,
          email: this.model.data.userMail,
          competitionId: this.curInfoArray.competitionId
        }
      } else if (k === '-2') {
        param = {
          id: this.model.data.id,
          name: this.model.data.leaderNameNew,
          phone: this.model.data.userPhoneNew,
          email: this.model.data.userMailNew,
          competitionId: this.curInfoArray.competitionId
        }
      } else {
        param = {
          id: this.model.temp[k].id,
          name: this.model.temp[k].userName,
          phone: this.model.temp[k].userPhone,
          email: this.model.temp[k].userMail,
          competitionId: this.curInfoArray.competitionId
        }
      }

      // 队内迁移感知：当前值若源自队友原值（互换/迁移/本人未改），跳过外部占用查重，避免误报"当前用户已报名"
      const normalizedValue = isPhoneField ? this.normalizePhone(value) : this.normalizeEmail(value)
      const originalSet = isPhoneField ? this.originalTeamPhones : this.originalTeamEmails
      if (normalizedValue && originalSet && originalSet.has(normalizedValue)) {
        // 跳过占用查重，仅保留二要素真实姓名校验（与原 verifyUserInfo 成功分支一致）
        if (this.shouldRunTwoFactorVerification(k)) {
          verifyTwo(param).then(res => {
            if (res.success) callback()
            else callback(new Error(this.globalDataArray.siteTemplateLanguage.authentication_failed))
          }).catch(() => callback(new Error('验证失败，请稍后重试')))
        } else {
          callback()
        }
        return
      }

      console.log(`validateContactInfo: 进行重复性验证，参数:`, param)
      const list = []
      list.push(param)
      verifyUserInfo(list).then(res => {
        if (res.success) {
          if (this.shouldRunTwoFactorVerification(k)) {
            verifyTwo(param).then(res => {
              if (res.success) {
                const isValid = res.result
                callback()
              } else {
                callback(new Error(this.globalDataArray.siteTemplateLanguage.authentication_failed))
              }
            })
          } else {
            callback()
          }
        } else {
          // 使用后端返回的具体错误信息
          callback(new Error(this.globalDataArray.siteTemplateLanguage.already_registered))
        }
      }).catch(error => {
        console.error('用户信息验证失败:', error)
        callback(new Error('验证失败，请稍后重试'))
      })
    },

    /**
     * 队员联系方式是否与登录用户（队长）重复
     * @param {'phone'|'email'} contactType
     */
    isMemberContactSameAsLoginUser(value, contactType, k) {
      if (k === '-1' || k === '-2') {
        return false
      }
      const current = (value || '').trim().toLowerCase()
      if (!current) {
        return false
      }
      const loginValues = []
      if (contactType === 'phone') {
        if (this.model.data.userPhone) {
          loginValues.push(String(this.model.data.userPhone).trim().toLowerCase())
        }
        if (this.model.data.userPhoneNew) {
          loginValues.push(String(this.model.data.userPhoneNew).trim().toLowerCase())
        }
      } else {
        if (this.model.data.userMail) {
          loginValues.push(String(this.model.data.userMail).trim().toLowerCase())
        }
        if (this.model.data.userMailNew) {
          loginValues.push(String(this.model.data.userMailNew).trim().toLowerCase())
        }
      }
      return loginValues.some(v => v && v === current)
    },
    getMemberLoginConflictMessage() {
      return (this.globalDataArray.siteTemplateLanguage &&
        this.globalDataArray.siteTemplateLanguage.system_parameter_error_repeat) ||
        '队员信息与登录用户部分信息重复'
    },

    validateEmail(rule, value, callback) {
      // 如果值为空，直接通过验证（由必填规则单独处理）
      if (!value || value.trim() === '') {
        callback()
        return
      }

      // 更严格的邮箱格式正则表达式
      const emailRegex = /^[a-zA-Z0-9]([a-zA-Z0-9._-])*[a-zA-Z0-9]@[a-zA-Z0-9]([a-zA-Z0-9.-])*[a-zA-Z0-9]\.[a-zA-Z]{2,}$/

      // 基本格式验证
      if (!emailRegex.test(value.trim())) {
        callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
        return
      }

      // 额外的格式限制检查
      const trimmedValue = value.trim()

      // 检查连续的点号
      if (trimmedValue.includes('..')) {
        callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
        return
      }

      // 检查邮箱长度（总长度不超过254字符，本地部分不超过64字符）
      if (trimmedValue.length > 254) {
        callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
        return
      }

      const [localPart, domainPart] = trimmedValue.split('@')
      if (localPart.length > 64) {
        callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
        return
      }

      // 检查域名部分是否过长
      if (domainPart && domainPart.length > 253) {
        callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
        return
      }

      callback()
    },

    // 保持向后兼容性，将旧方法重定向到新方法
    validateNumber(rule, value, callback) {
      this.validateEmail(rule, value, callback)
    },
    // 验证输入的字符串是否符合中国的身份证号码格式。身份证号码可以是15位或18位数字，其中18位的最后一位可以是数字或字母X（大小写均可）
    validateID(rule, value, callback, k) {
      // 如果值为空，直接通过验证（由必填规则单独处理）
      if (!value || value.trim() === '') {
        callback()
        return
      }

      const regID = new RegExp(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/)
      if (!regID.test(value.trim())) {
        callback(new Error('请输入正确的身份证格式'))
        return
      }

      // 身份证格式验证通过，检查是否需要进行三要素验证
      if (this.verify.boolThree) {
        // 检查语言状态，只有中文用户才进行身份证三要素验证
        let shouldValidate = false

        if (k === '-1') {
          // 队长身份证验证，使用与手机号验证相同的逻辑
          shouldValidate = this.shouldValidatePhone()
        } else if (k === '-2') {
          // 团队信息身份证验证，使用与手机号验证相同的逻辑
          shouldValidate = this.shouldValidatePhone()
        } else {
          // 队员身份证验证，使用与队员手机号验证相同的逻辑
          shouldValidate = this.shouldValidatePhoneForMember(k)
        }

        // 只有中文用户才进行三要素验证
        if (!shouldValidate) {
          console.log('非中文用户，跳过身份证三要素验证')
          callback()
          return
        }
        let param = {}
        let name = ''
        let phone = ''

        // 根据不同场景获取姓名和手机号
        if (k === '-1') {
          name = this.model.data.leaderName
          phone = this.model.data.userPhone
          param = {
            name: name,
            phone: phone,
            cardNo: value.trim(),
            competitionId: this.curInfoArray.competitionId
          }
        } else if (k === '-2') {
          name = this.model.data.leaderNameNew
          phone = this.model.data.userPhoneNew
          param = {
            name: name,
            phone: phone,
            cardNo: value.trim(),
            competitionId: this.curInfoArray.competitionId
          }
        } else {
          name = this.model.temp[k].userName
          phone = this.model.temp[k].userPhone
          param = {
            name: name,
            phone: phone,
            cardNo: value.trim(),
            competitionId: this.curInfoArray.competitionId
          }
        }

        // 检查姓名和手机号是否都不为空
        if (!name || name.trim() === '') {
          callback(new Error('请先填写姓名'))
          return
        }

        if (!phone || phone.trim() === '') {
          callback(new Error('请先填写手机号'))
          return
        }

        // 验证手机号格式
        if (this.mobileNumberRule) {
          const phoneRegex = new RegExp(this.mobileNumberRule.replace(/^\/|\/$/g, ''))
          if (!phoneRegex.test(phone.trim())) {
            callback(new Error('请先填写正确格式的手机号'))
            return
          }
        }

        // 所有信息都填写正确，调用三要素验证接口
        console.log('身份证三要素验证参数:', param)
        threeVerification(param).then(res => {
          if (res.success) {
            callback()
          } else {
            callback(new Error(res.message))
          }
        }).catch(error => {
          console.error('三要素验证接口调用失败:', error)
          callback(new Error('身份证验证失败，请稍后重试'))
        })
      } else {
        callback()
      }
    },
    validatePhone(rule, value, callback, k) {
      // 如果值为空，直接通过验证（适用于英文用户不需要填写联系方式的情况）
      if (!value || value.trim() === '') {
        console.log(`validatePhone: 值为空，直接通过验证`)
        callback()
        return
      }

      const regID = new RegExp(this.mobileNumberRule.replace(/^\/|\/$/g, ''))
      if (!regID.test(value)) {
        callback(new Error('请输入正确的手机号格式 '))
        return
      }

      // 队员手机号不能与登录用户（队长）相同
      if (this.isMemberContactSameAsLoginUser(value, 'phone', k)) {
        callback(new Error(this.getMemberLoginConflictMessage()))
        return
      }

      // 格式正确，继续进行重复性验证
      let param = {}
      if (k === '-1') {
        param = {
          id: this.model.data.id,
          name: this.model.data.leaderName,
          phone: value,
          email: this.model.data.userMail,
          competitionId: this.curInfoArray.competitionId
        }
      } else if (k === '-2') {
        param = {
          id: this.model.data.id,
          name: this.model.data.leaderNameNew,
          phone: value,
          email: this.model.data.userMailNew,
          competitionId: this.curInfoArray.competitionId
        }
      } else {
        param = {
          id: this.model.temp[k].id,
          name: this.model.temp[k].userName,
          phone: value,
          email: this.model.temp[k].userMail,
          competitionId: this.curInfoArray.competitionId
        }
      }

      console.log(`validatePhone: 进行重复性验证，参数:`, param)
      const list = []
      list.push(param)
      verifyUserInfo(list).then(res => {
        if (res.success) {
          if (this.shouldRunTwoFactorVerification(k)) {
            verifyTwo(param).then(res => {
              if (res.success) {
                const isValid = res.result
                callback()
              } else {
                callback(new Error(this.globalDataArray.siteTemplateLanguage.authentication_failed))
              }
            })
          } else {
            callback()
          }
        } else {
          // 使用后端返回的具体错误信息
          callback(new Error(res.message || this.globalDataArray.siteTemplateLanguage.already_registered))
        }
      })
    },
    // 队长动态搜索学校名字
    searchCollege(value) {
      if (!value) {
        return
      }
      const filteredList = this.collegeList?.filter(item => {
        if (item.name.indexOf(value) > -1) {
          return true
        }
        return false
      }) || []

      // 去重处理，基于学校名称和标识码
      const uniqueList = filteredList.filter((item, index, self) => {
        return self.findIndex(i => i.name === item.name && i.identificationCode === item.identificationCode) === index
      })

      this.filterdCollegeList = uniqueList
    },
    // 队员学校搜索
    searchCollege1(value, k) {
      const filteredList = this.collegeList.filter(item => {
        return item.name.indexOf(value) > -1
      })

      // 去重处理，基于学校名称和标识码
      const uniqueList = filteredList.filter((item, index, self) => {
        return self.findIndex(i => i.name === item.name && i.identificationCode === item.identificationCode) === index
      })

      console.log(uniqueList, 'filteredList after deduplication')
      const exist = this.model.temp[k]
      this.$set(this.model.temp[k], 'filterdCollegeList', uniqueList)
    },

    // 删除单个队员
    delPerson(index) {
      const that = this
      console.log(this.model.temp[index], 'this.model.temp[index]')
      if (this.model.temp[index].id) {
        const params = {
          id: this.model.temp[index].id
        }
        Modal.confirm({
          title: this.globalDataArray.siteTemplateLanguage.person_delete_user,
          content: '',
          okText: this.globalDataArray.siteTemplateLanguage.verify,
          cancelText: this.globalDataArray.siteTemplateLanguage.cancel,
          async onOk() {
            const res = await deleteMember(params)
            if (res.success) {
              message.success(that.globalDataArray.siteTemplateLanguage.success_withdrawn)
              that.model['temp'].splice(index, 1)
            } else {
              message.error(res.message)
            }
          },
          onCancel() {
            console.log('Cancel')
          }
        })
      } else {
        that.model['temp'].splice(index, 1)
      }
    },
    addPerson() {
      const that = this

      if (that.limitNum == null) {
        that.limitNum = 0
      }

      const hasMemberNum = this.model['temp'].length

      if (hasMemberNum >= that.limitNum) {
        that.$message.warning('成员总数超出限制！')
        return false
      }

      // 获取当前全局语言环境，确保新队员有正确的语言标识
      const currentLanguage = this.curInfoArray?.currentLanguge || this.globalLanguage || 'zh_CN'

      let itemParam = {
        userName: '',
        categoryId: '',
        competitionId: '',
        nation: '',
        teamName: '',
        teamType: '',
        companyType: '',
        jobType: '',
        language: currentLanguage,
        countryCode: '',
        cityCode: '',
        teamList: structuredClone(this.teamMemberList),
        filterdCollegeList: []
      }
      itemParam = { ...itemParam, ...this.staging }
      this.model['temp'].push(itemParam)
    },

    // 切换单位类型
    onChangeCompany(e) {
      const newValue = e.target.value !== '02' ? '1' : '0'
      this.showList.forEach(item => {
        if (item.fieldCode === 'company') {
          item.isShow = newValue
          item.isDoubleCheck = e.target.value === '02'
        }
      })
      if (newValue === '0' && this.model.data.jobType === '02') {
        this.changeStudent(this.showList, '1')
      } else {
        this.changeStudent(this.showList, '0')
      }
    },

    // 键盘输入过滤
    handleNumberInput(e, fieldCode, k) {
      // 过滤非数字字符
      const value = e.target.value.replace(/[^\d]/g, '')
      if (k === '-1') {
        // 更新模型值
        this.$set(this.model.data, fieldCode, value)
      } else {
        this.$set(this.model.temp[k], fieldCode, value)
      }
    },

    changeStudent(listStudent, value) {
      listStudent.forEach(item => {
        if (item.fieldCode === 'educational') {
          item.isShow = value
        }
        if (item.fieldCode === 'studentUrl') {
          item.isShow = value
        }
        if (item.fieldCode === 'onlineCode') {
          item.isShow = value
        }
      })
    },

    // 切换职业
    onChangeJob(e, k) {
      console.log(e)
      const newValue = e.target.value === '02' ? '1' : '0'
      if (k === '-1') {
        if (this.model.data.companyType !== '02') {
          this.changeStudent(this.showList, '0')
          return
        }
        this.showList.forEach(item => {
          if (item.fieldCode === 'educational') {
            item.isShow = newValue
          }
          if (item.fieldCode === 'studentUrl') {
            item.isShow = newValue
          }
          if (item.fieldCode === 'onlineCode') {
            item.isShow = newValue
          }
        })
      } else {
        if (this.model.temp[k].companyType !== '02') {
          this.changeStudent(this.model.temp[k].teamList, '0')
          return
        }
        this.model.temp[k].teamList.forEach(item => {
          if (item.fieldCode === 'educational') {
            item.isShow = newValue
          }
          if (item.fieldCode === 'studentUrl') {
            item.isShow = newValue
          }
          if (item.fieldCode === 'onlineCode') {
            item.isShow = newValue
          }
        })
      }
    },

    // 省市联动
    handleProvinceChange(e, ind) {
      console.log('=== handleProvinceChange 被调用 ===')
      console.log('省份选择事件 e:', e, 'ind:', ind)
      const that = this
      const params = 'pid=' + e.key + '&language=' + this.globalLanguage
      console.log('省市联动API请求参数:', params)

      getCityList(params).then(res => {
        console.log('省市联动API返回:', res)
        if (res.success) {
          const cityList = res.result.map(ca => {
            return {
              ...ca,
              itemValue: ca.id,
              itemText: ca.title
            }
          })
          console.log('省市联动处理后的城市列表:', cityList)

          if (ind === '-1') {
            console.log('省市联动-队长数据')
            this.showList.forEach(item => {
              if (item.fieldCode === 'cityCode') {
                console.log('省市联动-为队长设置城市列表')
                this.$set(item, 'list', cityList)
              }
            })
            this.model.data.cityCode = undefined
          } else {
            console.log(`省市联动-队员${ind}数据`)
            that.model.temp[ind].teamList.forEach(item => {
              if (item.fieldCode === 'cityCode') {
                console.log(`省市联动-为队员${ind}设置城市列表`)
                this.$set(item, 'list', cityList)
              }
            })
            that.model.temp[ind].cityCode = undefined
          }
        } else {
          console.log('省市联动API调用失败:', res.message || '未知错误')
        }
      }).catch(error => {
        console.error('省市联动请求失败:', error)
      })
    },

    onChangeCompany1(e, k) {
      const newValue = e.target.value !== '02' ? '1' : '0'
      this.model.temp[k].teamList.forEach(item => {
        if (item.fieldCode === 'company') {
          item.isShow = newValue
          item.isDoubleCheck = e.target.value === '02'
        }
      })
      if (newValue === '0' && this.model.temp[k].jobType === '02') {
        this.changeStudent(this.model.temp[k].teamList, '1')
      } else {
        this.changeStudent(this.model.temp[k].teamList, '0')
      }
    },

    // 获取学院列表
    async getCollegeList() {
      const { success, result } = await getCollegeList()
      if (success) {
        this.collegeList = result
      }
    },

    onChangeGroupId(id) {
      this.model.data.grade = undefined
      // 1. 在 groupArray 中快速查找匹配的组
      const targetGroup = this.groupArray.find(group => group.id === id)
      if (!targetGroup) return

      // 2. 转换年级数据为下拉框需要的格式
      const gradeOptions = targetGroup.sub.map(grade => ({
        ...grade,
        itemValue: grade.id,
        itemText: grade.title
      }))

      // 3. 在 columnList 中找到对应的字段并更新
      const gradeField = this.columnList.find(item => item.fieldCode === 'grade')
      if (gradeField) {
        // 使用 $set 确保响应式更新
        this.$set(gradeField, 'list', gradeOptions)
      }
    },

    // 获取赛事组别
    async getGroupList() {
      const res = await getGroupList()
      if (res.success) {
        this.groupArray = res.result.map(item => {
          return {
            ...item,
            itemValue: item.id,
            itemText: item.title
          }
        })
      }
    },

    // 编辑模式下检查省份并加载城市数据
    async loadCityDataIfProvinceExists() {
      console.log('=== loadCityDataIfProvinceExists 开始执行 ===')
      console.log('model.data:', this.model.data)
      console.log('model.temp:', this.model.temp)

      // 检查队长的省份
      if (this.model.data && this.model.data.countryCode) {
        console.log('队长的countryCode:', this.model.data.countryCode)
        let provinceKey = null

        // 处理不同格式的countryCode
        if (typeof this.model.data.countryCode === 'object' && this.model.data.countryCode.key) {
          provinceKey = this.model.data.countryCode.key
        } else if (typeof this.model.data.countryCode === 'string' && this.model.data.countryCode) {
          provinceKey = this.model.data.countryCode
        }

        if (provinceKey) {
          console.log('队长省份key:', provinceKey)
          await this.loadCityData({ key: provinceKey }, '-1')
        }
      }

      // 检查队员的省份
      if (this.model.temp && Array.isArray(this.model.temp)) {
        for (let i = 0; i < this.model.temp.length; i++) {
          const member = this.model.temp[i]
          if (member && member.countryCode) {
            console.log(`队员${i}的countryCode:`, member.countryCode)
            let provinceKey = null

            // 处理不同格式的countryCode
            if (typeof member.countryCode === 'object' && member.countryCode.key) {
              provinceKey = member.countryCode.key
            } else if (typeof member.countryCode === 'string' && member.countryCode) {
              provinceKey = member.countryCode
            }

            if (provinceKey) {
              console.log(`队员${i}省份key:`, provinceKey)
              await this.loadCityData({ key: provinceKey }, i)
            }
          }
        }
      }
    },

    // 判断是否未成年（距今小于18岁）
    isUnderAge(birthday) {
      if (!birthday) {
        return false
      }

      const today = this.moment()
      const birthDate = this.moment(birthday)

      return today.diff(birthDate, 'years') < 18
    },

    // 生日变更联动：控制未成年附件字段显示
    onBirthdayChange(date, k) {
      const isUnderAge = this.isUnderAge(date)

      this.toggleUnderAgeFileUrl(k, isUnderAge)
    },

    // 切换未成年附件字段显示状态
    toggleUnderAgeFileUrl(k, show) {
      const value = show ? '1' : '0'

      if (k === '-1') {
        // 队长
        this.showList.forEach(item => {
          if (item.fieldCode === 'underAgeFileUrl') {
            item.isShow = value
          }
        })

        if (!show) {
          this.model.data.underAgeFileUrl = ''
        }
      }
      else {
        // 队员
        this.model.temp[k].teamList.forEach(item => {
          if (item.fieldCode === 'underAgeFileUrl') {
            item.isShow = value
          }
        })

        if (!show) {
          this.model.temp[k].underAgeFileUrl = ''
        }
      }
    },

    // 加载城市数据的通用方法
    async loadCityData(countryCodeObj, ind) {
      try {
        console.log(`=== loadCityData 开始执行，ind: ${ind} ===`)
        console.log('countryCodeObj:', countryCodeObj)
        console.log('globalLanguage:', this.globalLanguage)

        const params = 'pid=' + countryCodeObj.key + '&language=' + this.globalLanguage
        console.log('请求参数:', params)

        const res = await getCityList(params)
        console.log('API返回结果:', res)

        if (res.success) {
          const cityList = res.result.map(ca => {
            return {
              ...ca,
              itemValue: ca.id,
              itemText: ca.title
            }
          })
          console.log('处理后的城市列表:', cityList)

          if (ind === '-1') {
            // 队长数据
            console.log('处理队长城市数据，showList:', this.showList)
            this.showList.forEach(item => {
              if (item.fieldCode === 'cityCode') {
                console.log('找到cityCode字段，设置城市列表')
                this.$set(item, 'list', cityList)
                console.log('设置后的item:', item)
              }
            })
          } else {
            // 队员数据
            console.log(`处理队员${ind}城市数据`)
            if (this.model.temp[ind] && this.model.temp[ind].teamList) {
              this.model.temp[ind].teamList.forEach(item => {
                if (item.fieldCode === 'cityCode') {
                  console.log(`为队员${ind}设置城市列表`)
                  this.$set(item, 'list', cityList)
                }
              })
            }
          }
        } else {
          console.log('API调用失败:', res.message || '未知错误')
        }
      } catch (error) {
        console.error('加载城市数据失败:', error)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.cont {
  height: 60vh;
}

.btn-disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
}

::v-deep .ant-input-disabled {
  background-color: #f7f7f7;
  color: rgba(0, 0, 0, 0.65) !important;
}
::v-deep .ant-select-disabled {
  background-color: #f7f7f7 !important;
  color: rgba(0, 0, 0, 0.65) !important;
}

/*@media only screen and (max-width:1024px){
  .addPrsonTemp .ant-btn{margin-top:0px;}
}
@media only screen and (max-width:640px){
  .addPrsonTemp .ant-btn{margin-top:0px;}
}*/
</style>
